import store from '../store'
/**
 * 判断用户是否拥有按钮操作权限
 * 根据传入的权限功能key，
 * @param {String} key
 * @returns
 */
export function checkFunction(key) {
  const functionList = store.getters.functionKey
  const index = functionList.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}
/**
 * 判断CRM客户是否有权限
 * @param {String} key
 * @returns
 */
export function checkCrmButton(key) {
  const functionList = store.getters.crmButtonAuth
  const index = functionList.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}

/**
 * 判断Order按钮权限
 * @param {String} key
 * @returns
 */
 export function checkOrderButton(key) {
  const functionList = store.getters.orderButtonAuth
  const index = functionList.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}

/**
 * 判断财务按钮权限
 * @param {String} key
 * @returns
 */
 export function checkFinanceButton(key) {
  const functionList = store.getters.financeButtonAuth
  const index = functionList.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}

export default {
  checkFunction,
  checkCrmButton,
  checkOrderButton,
  checkFinanceButton
}